export default "__VITE_ASSET__DvWoEaAX__"